import {Flex, Tag, Text} from '@chakra-ui/react';
import {AnimatePresence, motion} from 'framer-motion';
import React from 'react';
import ButtonMinor from '../../../components/ButtonMinor';

const OpenModalButton = ({
  accentColor = null,
  bgColor,
  color,
  count = 0,
  label,
  leftIcon = null,
  onClick,
  rightIcon = null,
  worldType,
}) => (
  <ButtonMinor
    bg={bgColor}
    borderRadius="none"
    color={color}
    fontWeight="normal"
    h="3em"
    justifyContent="space-between"
    onClick={() => onClick(worldType)}
    w="full"
  >
    <Flex gap={6} alignItems="center" minW={0}>
      {leftIcon}
      <Text fontSize="sm" isTruncated>{label}</Text>
      {(count > 0) && (
        <Tag
          alignItems="center"
          bg={accentColor}
          color="black"
          fontSize="sm"
          h="1.5em"
          justifyContent="center"
          minW="2.5em"
          overflow="hidden"
          position="relative"
        >
          <AnimatePresence initial={false} mode="popLayout">
            <motion.span
              key={count}
              animate={{opacity: 1, y: 0}}
              exit={{opacity: 0, y: -8}}
              initial={{opacity: 0, y: 8}}
              style={{
                alignItems: 'center',
                display: 'flex',
                inset: 0,
                justifyContent: 'center',
                position: 'absolute',
              }}
              transition={{duration: 0.18, ease: 'easeOut'}}
            >
              {count}
            </motion.span>
          </AnimatePresence>
        </Tag>
      )}
    </Flex>
    {rightIcon}
  </ButtonMinor>
);

export default OpenModalButton;
